// App do técnico (2026-10-07) — rota pública no __root.tsx (sessão própria
// do técnico, ver services/technician-app.service.ts).
import { createFileRoute } from "@tanstack/react-router";
import { TechnicianApp } from "@/components/technician-app/technician-app";

export const Route = createFileRoute("/tecnico")({
  head: () => ({
    meta: [{ title: "App do Técnico" }, { name: "theme-color", content: "#ffffff" }],
  }),
  component: TechnicianApp,
});
